/** @format */
import { useTranslation } from 'next-i18next';
import { useContext } from 'react';

import { MarketContext } from '@toucan/client/global/market';

export const useProductUrl = (sku?: string, modelSlug?: string) => {
    const { activeMarket } = useContext(MarketContext);
    const { t } = useTranslation();

    const marketSlug = activeMarket.slug;
    const productSlug = t('product', { ns: 'urls' });

    const href =
        modelSlug && sku
            ? `/${marketSlug}/${productSlug}/${modelSlug}/sku-${sku}`
            : '';
    const templatePath =
        modelSlug && sku ? `/product?slug=${modelSlug}&sku=${sku}` : '';

    return {
        href,
        templatePath,
    };
};
